module.exports = __webpack_public_path__ + "static/media/favicon.2c2a4f28.ico";